import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import {TIPS} from "../../../consts/tips";

import { useFormErrors } from '../../hooks/useFormErrors';
import { CheckboxButton, FormError, FormLabel, InputCodigo, InputEntidad, Modal } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const TipoRelacionCertificadoApremioPersonaModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        codigo: '',
        descripcion: '',
        idTipoControlador: 0,
        esSucesor: false
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
        showInfo: false
    });

    const mount = () => {

        if (props.id > 0) {
            FindTipoRelacionCertificadoApremioPersona();
        }
   
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [ formValues, formHandle, , formSet ] = useForm({
        codigo: '',
        descripcion: '',
        idTipoControlador: 0,
        esSucesor: false
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0) {
                AddTipoRelacionCertificadoApremioPersona();
            }
            else {
                ModifyTipoRelacionCertificadoApremioPersona();
            }
        };
    };
    const handleClickCancelar = () => {
        props.onDismiss();
    }
    
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  

    // funciones
    function getErrors() {

        const errors = {};

        if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.descripcion.length === 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED

        return errors;
    }   
    
    function FindTipoRelacionCertificadoApremioPersona() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {               
                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });
                formSet({
                    codigo: data.codigo,
                    descripcion: data.descripcion,
                    idTipoControlador: data.idTipoControlador,
                    esSucesor: data.esSucesor ?? false
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_RELACION_CERTIFICADO_APREMIO_PERSONA,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddTipoRelacionCertificadoApremioPersona() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveTipoRelacionCertificadoApremioPersona(method, paramsUrl);
    }
    
    function ModifyTipoRelacionCertificadoApremioPersona() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveTipoRelacionCertificadoApremioPersona(method, paramsUrl);
    }    

    function SaveTipoRelacionCertificadoApremioPersona(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
                ...state.entity,
                codigo: formValues.codigo,
                descripcion: formValues.descripcion,
                idTipoControlador: formValues.idTipoControlador,
                esSucesor: formValues.esSucesor
        };
    
        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.TIPO_RELACION_CERTIFICADO_APREMIO_PERSONA,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

    return (
        <>
    
        <Modal
            size="lg"
            title={`Tipo relación certificado apremio persona: ${(props && props.id > 0) ? state.entity.codigo : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            onEscape={handleClickCancelar}
            body={(<>
    
                    <div className="row">
                        <div className="mb-3 col-12 col-md-2">
                            <FormLabel htmlFor="codigo" required>Código</FormLabel>
                            <InputCodigo
                                name="codigo"
                                placeholder=""
                                className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                value={ formValues.codigo }
                                onChange={ formHandle }
                                disabled={props.disabled}
                                maxLength={20}
                            />
                            <FormError message={errorOf('codigo')} />
                        </div>
                        <div className="mb-3 col-12 col-md-4">
                            <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                            <input
                                name="descripcion"
                                type="text"
                                placeholder=""
                                className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                value={ formValues.descripcion }
                                onChange={ formHandle }
                                disabled={props.disabled}
                            />
                            <FormError message={errorOf('descripcion')} />
                        </div>
                        <div className="mb-3 col-12 col-md-6">
                            <label htmlFor="idTipoControlador" className="form-label">Tipo de controlador</label>
                            <InputEntidad
                                name="idTipoControlador"
                                placeholder=""
                                className="form-control"
                                value={ formValues.idTipoControlador }
                                onChange={ formHandle }
                                disabled={props.disabled}
                                title="Tipo controlador"
                                entidad="TipoControlador"
                                onFormat= {(row) => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                memo={false}
                            />
                            <FormError />
                        </div>

                    </div>

                    <div className="row">
                        <div className="mb-3 col-12 col-md-3">
                            <FormLabel htmlFor="esSucesor">Es sucesor/a</FormLabel>
                            <CheckboxButton
                                name="esSucesor"
                                label="Es sucesor/a"
                                checked={ formValues.esSucesor }
                                onChange={ formHandle }
                                disabled={props.disabled}
                            />
                        </div>
                    </div>


            </>)}
            footer={!props.disabled ? (<>
                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
                    <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
            </>) : (
                    <button className="btn back-button" data-dismiss="modal"onClick={ (event) => handleClickCancelar() }>Volver</button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />

        </>
      );
    }

TipoRelacionCertificadoApremioPersonaModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

TipoRelacionCertificadoApremioPersonaModal.defaultProps = {
    disabled: false
};

export default TipoRelacionCertificadoApremioPersonaModal;